import { ListOfOffersPrices } from "./OffersPrices.types";

import { IMessageBar } from "@/core/libs/message-bar";

export enum OffersPricesActionsTypes {
  CREATE_REQUEST = "offers-prices/CREATE_REQUEST",
  CREATE_FAIL = "offers-prices/CREATE_FAIL",
  CREATE_SUCCESS = "offers-prices/CREATE_SUCCESS",
  DISMISS_MESSAGE = "offers-prices/DISMISS_MESSAGE",
  EDIT_REQUEST = "offers-prices/EDIT_REQUEST",
  EDIT_FAIL = "offers-prices/EDIT_FAIL",
  EDIT_SUCCESS = "offers-prices/EDIT_SUCCESS",
  LIST_REQUEST = "offers-prices/LIST_REQUEST",
  LIST_FAIL = "offers-prices/LIST_FAIL",
  LIST_SUCCESS = "offers-prices/LIST_SUCCESS"
}

export interface OffersPricesState {
  isLoadingList: boolean;
  list?: ListOfOffersPrices;
  message?: IMessageBar;
}

interface CreateRequest {
  type: OffersPricesActionsTypes.CREATE_REQUEST;
}

interface CreateError {
  type: OffersPricesActionsTypes.CREATE_FAIL;
  payload: {
    message: IMessageBar;
  };
}

interface CreateSuccess {
  type: OffersPricesActionsTypes.CREATE_SUCCESS;
  payload: {
    message: IMessageBar;
  };
}

interface DismissMessage {
  type: OffersPricesActionsTypes.DISMISS_MESSAGE;
}

interface EditRequest {
  type: OffersPricesActionsTypes.EDIT_REQUEST;
}

interface EditError {
  type: OffersPricesActionsTypes.EDIT_FAIL;
  payload: {
    message: IMessageBar;
  };
}

interface EditSuccess {
  type: OffersPricesActionsTypes.EDIT_SUCCESS;
  payload: {
    message: IMessageBar;
  };
}

interface ListRequest {
  type: OffersPricesActionsTypes.LIST_REQUEST;
}

interface ListError {
  type: OffersPricesActionsTypes.LIST_FAIL;
}

interface ListSuccess {
  type: OffersPricesActionsTypes.LIST_SUCCESS;
  payload: {
    list: ListOfOffersPrices;
  };
}

export type OffersPricesReducerActions =
  | CreateRequest
  | CreateError
  | CreateSuccess
  | DismissMessage
  | EditRequest
  | EditError
  | EditSuccess
  | ListRequest
  | ListError
  | ListSuccess;
